export default function getDataFromDate(dateString) {
  if (!dateString) return null;
  let date = new Date(dateString);

  const day = date?.getDate();
  const month = date?.getMonth() + 1;
  const year = date?.getFullYear();
  const ISOString = date?.toISOString();
  const ISOStringShort = date?.toISOString()?.substring(0, 10);

  const res = {
    day,
    month,
    year,
    ISOString,
    ISOStringShort,
  };

  return res;
}
